export const contentStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  width: '100%',
  minWidth: 0,
};

export const subtitleStyles = {
  display: 'block',
};
